import { Drawer, notification, Spin } from "antd";
import requestService from "api/request";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { useCopyToClipboard } from "usehooks-ts";

interface Props {
  open: boolean;
  onClose: () => void;
}
const ProfileDrawer = ({ open, onClose }: Props) => {
  const { user } = useAppSelector((state) => state.app) as any;
  const [loading, setLoading] = useState(false);
  const [copiedText, copy] = useCopyToClipboard();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleLogout = async () => {
    setLoading(true);
    try {
      const res = await requestService.post("/profile/logout");
      if (res && res.data) {
        localStorage.clear();
        navigate("/");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const handleCopy = (text: string) => {
    console.log(text);

    copy(text)
      .then(() => {
        notification.success({
          message: "Copied!",
          duration: 5,
        });
      })
      .catch((error) => {
        console.error("Failed to copy!", error);
      });
  };
  return (
    <Drawer
      title={user?.email}
      placement={"right"}
      closable={true}
      onClose={onClose}
      open={open}
    >
      <Spin spinning={loading} fullscreen />
      <div
        data-v-9b258259=""
        className="micro-user flex flex-col relative pt-24px max-h-inherit text-14px overflow-hidden h-full !pt-0"
      >
        <div
          data-v-9b258259=""
          className="flex-1 px-24px pb-0 overflow-y-auto overflow-x-hidden"
        >
          <div
            data-v-9570916d=""
            data-v-9b258259=""
            className="micro-userInfo mb-8px overflow-hidden"
          >
            <div
              data-v-9570916d=""
              className="p-16px cursor-pointer rounded-8px border-1px border-borderStrengthOne hover:bg-[var(--background-secondary)]"
            >
              {/**/}
              <div data-v-9570916d="" className="flex items-center">
                <div data-v-9570916d="" className="w-48px h-48px mr-14px">
                  <div
                    data-v-a0589d33=""
                    data-v-9570916d=""
                    className="micro-bit-avatar"
                    style={{ width: 48, height: 48 }}
                  >
                    <span
                      data-v-a0589d33=""
                      className="mi-avatar mi-avatar--circle"
                    >
                      <img
                        src="https://www.bitget.com.vn//baseasset/img/dashboardNew/avatar-default.svg"
                        className="w-full h-full"
                      />
                    </span>
                    {/**/}
                  </div>
                </div>
                <div data-v-9570916d="">
                  <div
                    data-v-9570916d=""
                    className="micro-userInfo-displayName text-primaryText max-w-220px text-16px font-700 truncate cursor-pointer leading-24px not-jump mi-tooltip__trigger mi-tooltip__trigger"
                  >
                    {user?.email}
                  </div>
                  <div
                    data-v-9570916d=""
                    className="not-jump mt-2px flex items-center text-thirdText text-12px cursor-pointer leading-18px"
                  >
                    UID: {user?._id}
                  </div>
                </div>
              </div>
              <div
                data-v-9570916d=""
                className="mt-16px h-18px flex items-center"
              >
                <div
                  data-v-9570916d=""
                  className="not-jump mr-10px cursor-pointer"
                >
                  <div
                    data-v-54cd041d=""
                    data-v-9570916d=""
                    className="micro-verified-label relative flex items-center not-jump mi-tooltip__trigger"
                  >
                    <span data-v-54cd041d="" className="absolute not-jump">
                      {user?.is_kyc === "success" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="size-6 text-green-500"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="size-6 text-yellow-400"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z"
                          />
                        </svg>
                      )}
                    </span>
                    <div
                      data-v-54cd041d=""
                      className="text-12px font-700 leading-18px h-18px ml-12px pl-12px pr-6px rounded-2px not-jump text-unverified !text-[#fff]"
                    >
                      {user?.is_kyc === "success"
                        ? t("Đã xác minh")
                        : user?.is_kyc === "pending"
                          ? t("Đang chờ xác minh")
                          : t("Chưa xác minh")}
                    </div>
                  </div>
                </div>
                <a
                  data-v-9570916d=""
                  className="text-primaryText sep-vip-label relative flex items-center cursor-pointer mr-10px"
                  href="/vi/fee"
                  target="_self"
                >
                  <span className="absolute flex items-center">
                    <img
                      src="https://www.bitget.com.vn/micro-runtime/assets/icon-viplevel-0.9a38c504.svg"
                      className="w-18px h-2opx"
                      alt="vip_0"
                      loading="lazy"
                    />
                  </span>
                  <div className="micro-vip-tag text-12px font-700 leading-18px h-18px ml-12px pl-12px pr-6px rounded-2px bg-bgSecondary text-contentDisabled !text-[#fff]">
                    VIP {user?.level_vip}
                  </div>
                </a>
              </div>
              <div
                data-v-9570916d=""
                className="mt-16px h-18px flex items-center gap-2"
              >
                <div className="text-[#fff]">{t("Mã giới thiệu")} : {user?.code}</div>
                <div
                  className="cursor-pointer"
                  onClick={() => handleCopy(user?.code)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-[#fff]">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                  </svg>

                </div>
              </div>
            </div>
          </div>
          <div data-v-1b6285a2="" data-v-9b258259="" className="px-12px">
            {/**/}
            <div
              data-v-1b6285a2=""
              className="flex items-center mb-8px px-20px justify-between"
            >
              <Link
                data-v-1b6285a2=""
                className="text-primaryText flex flex-col items-center justify-center h-94px cursor-pointer"
                to="/deposit"
                target="_self"
              >
                <div className="size-[40px] flex justify-center items-center rounded-full border-[#fff] border">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
                    />
                  </svg>
                </div>

                <span
                  data-v-1b6285a2=""
                  className="mt-4px text-12px leading-18px text-center"
                >
                  {t("Nạp")}
                </span>
              </Link>
              <Link
                data-v-1b6285a2=""
                className="text-primaryText flex flex-col items-center justify-center h-94px cursor-pointer"
                to="/withdraw"
                target="_self"
              >
                <div className="size-[40px] flex justify-center items-center rounded-full border-[#fff] border">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
                    />
                  </svg>
                </div>
                <span
                  data-v-1b6285a2=""
                  className="mt-4px text-12px leading-18px text-center"
                >
                  {t("Rút")}
                </span>
              </Link>
              <a
                data-v-1b6285a2=""
                className="text-primaryText flex flex-col items-center justify-center h-94px cursor-pointer"
                href="#"
                target="_self"
              >
                <div className="size-[40px] flex justify-center items-center rounded-full border-[#fff] border">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                    />
                  </svg>
                </div>

                <span
                  data-v-1b6285a2=""
                  className="mt-4px text-12px leading-18px text-center"
                >
                  {t("Chuyển")}
                </span>
              </a>
            </div>
          </div>
          <div
            data-v-9b258259=""
            className="micro-menu-item px-8px w-full rounded-8px transition-[0.3s] hover:bg-bgSecondary cursor-pointer mb-6px last:mb-0"
            show-hover-arrow=""
          >
            <Link
              className="text-primaryText flex justify-between items-center h-40px"
              to="/account-setting"
              onClick={() => onClose()}
              target="_self"
            >
              <div className="flex justify-between items-center gap-10px">
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-20px h-20px min-w-20px"
                >
                  <g id="Icon24">
                    <path
                      id="Vector"
                      d="M3.125 4.58341L10 2.29175L16.875 4.58341V8.75008C16.875 12.6644 13.4839 16.4711 10.0008 17.7084C6.51688 16.4711 3.125 12.6653 3.125 8.75008V4.58341Z"
                      stroke="currentColor"
                      strokeWidth="1.25"
                      strokeLinejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M6.66644 9.16667L9.16644 11.6667L13.3331 7.5"
                      stroke="currentColor"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
                <span className="menu-label">{t("Bảo mật")}</span>
                {/**/}
              </div>
            </Link>
          </div>
          <div
            data-v-9b258259=""
            className="micro-menu-item px-8px w-full rounded-8px transition-[0.3s] hover:bg-bgSecondary cursor-pointer mb-6px last:mb-0"
            show-hover-arrow=""
          >
            <Link
              className="text-primaryText flex justify-between items-center h-40px"
              to={
                user?.is_kyc === "success" || user?.is_kyc === "pending"
                  ? "#"
                  : "/account-kyc"
              }
              target="_self"
              onClick={onClose}
            >
              <div className="flex justify-between items-center gap-10px">
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-20px h-20px min-w-20px"
                >
                  <g id="IdentificationCard">
                    <path
                      id="Vector"
                      d="M15.625 8.75C15.625 8.91576 15.5592 9.07473 15.4419 9.19194C15.3247 9.30915 15.1658 9.375 15 9.375H11.875C11.7092 9.375 11.5503 9.30915 11.4331 9.19194C11.3158 9.07473 11.25 8.91576 11.25 8.75C11.25 8.58424 11.3158 8.42527 11.4331 8.30806C11.5503 8.19085 11.7092 8.125 11.875 8.125H15C15.1658 8.125 15.3247 8.19085 15.4419 8.30806C15.5592 8.42527 15.625 8.58424 15.625 8.75ZM15 10.625H11.875C11.7092 10.625 11.5503 10.6908 11.4331 10.8081C11.3158 10.9253 11.25 11.0842 11.25 11.25C11.25 11.4158 11.3158 11.5747 11.4331 11.6919C11.5503 11.8092 11.7092 11.875 11.875 11.875H15C15.1658 11.875 15.3247 11.8092 15.4419 11.6919C15.5592 11.5747 15.625 11.4158 15.625 11.25C15.625 11.0842 15.5592 10.9253 15.4419 10.8081C15.3247 10.6908 15.1658 10.625 15 10.625ZM18.125 4.375V15.625C18.125 15.9565 17.9933 16.2745 17.7589 16.5089C17.5245 16.7433 17.2065 16.875 16.875 16.875H3.125C2.79348 16.875 2.47554 16.7433 2.24112 16.5089C2.0067 16.2745 1.875 15.9565 1.875 15.625V4.375C1.875 4.04348 2.0067 3.72554 2.24112 3.49112C2.47554 3.2567 2.79348 3.125 3.125 3.125H16.875C17.2065 3.125 17.5245 3.2567 17.7589 3.49112C17.9933 3.72554 18.125 4.04348 18.125 4.375ZM16.875 15.625V4.375H3.125V15.625H16.875ZM10.6047 12.9688C10.6461 13.1293 10.6221 13.2998 10.5378 13.4426C10.4536 13.5855 10.316 13.689 10.1555 13.7305C9.99489 13.7719 9.82442 13.7479 9.68157 13.6636C9.53872 13.5794 9.43519 13.4418 9.39375 13.2813C9.18828 12.4797 8.37344 11.875 7.49922 11.875C6.625 11.875 5.81094 12.4797 5.60469 13.2813C5.56325 13.4418 5.45971 13.5794 5.31686 13.6636C5.17401 13.7479 5.00355 13.7719 4.84297 13.7305C4.68239 13.689 4.54485 13.5855 4.4606 13.4426C4.37636 13.2998 4.35231 13.1293 4.39375 12.9688C4.59656 12.2139 5.07598 11.5629 5.73672 11.1453C5.3856 10.7963 5.14602 10.3508 5.04835 9.86549C4.95068 9.38013 4.99932 8.87671 5.1881 8.41902C5.37688 7.96134 5.6973 7.57002 6.10875 7.29465C6.52019 7.01929 7.00413 6.87229 7.49922 6.87229C7.9943 6.87229 8.47824 7.01929 8.88969 7.29465C9.30113 7.57002 9.62156 7.96134 9.81034 8.41902C9.99912 8.87671 10.0478 9.38013 9.95009 9.86549C9.85242 10.3508 9.61284 10.7963 9.26172 11.1453C9.92318 11.5623 10.403 12.2135 10.6055 12.9688H10.6047ZM7.5 10.625C7.74723 10.625 7.9889 10.5517 8.19446 10.4143C8.40002 10.277 8.56024 10.0818 8.65485 9.85335C8.74946 9.62495 8.77421 9.37361 8.72598 9.13114C8.67775 8.88866 8.5587 8.66593 8.38388 8.49112C8.20907 8.3163 7.98634 8.19725 7.74386 8.14902C7.50139 8.10079 7.25005 8.12554 7.02165 8.22015C6.79324 8.31476 6.59801 8.47498 6.46066 8.68054C6.32331 8.8861 6.25 9.12777 6.25 9.375C6.25 9.70652 6.3817 10.0245 6.61612 10.2589C6.85054 10.4933 7.16848 10.625 7.5 10.625Z"
                      fill="currentColor"
                    />
                  </g>
                </svg>
                {user?.is_kyc === "success" ? (
                  <span className="menu-label">{t("Đã xác minh")}</span>
                ) : (
                  <span className="menu-label">{t("Xác minh danh tính")}</span>
                )}

                {/**/}
              </div>
            </Link>
          </div>
          <div
            data-v-9b258259=""
            className="micro-menu-item px-8px w-full rounded-8px transition-[0.3s] hover:bg-bgSecondary cursor-pointer mb-6px last:mb-0"
            show-hover-arrow=""
          >
            <Link
              className="text-primaryText flex justify-between items-center h-40px"
              to={
                '/ref-user'
              }
              target="_self"
              onClick={onClose}
            >
              <div className="flex justify-between items-center gap-10px">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                </svg>

                <span className="menu-label">{t("Giới thiệu người chơi")}</span>
              </div>
            </Link>
          </div>
        </div>
        <div
          data-v-9b258259=""
          className="px-24px h-76px min-h-76px pt-8px mt-8px bottom-0 flex justify-center bg-[inherit]"
        >
          <button
            data-v-9b258259=""
            aria-disabled="false"
            type="button"
            className="mi-button mi-button--large is-round w-full"
            onClick={handleLogout}
          >
            {/*v-if*/}
            <span className="">{t("Đăng xuất")}</span>
            {/*v-if*/}
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default ProfileDrawer;
